import Link from "next/link";
import { useRouter } from "next/compat/router";

export default function Breadcrumb({ link, text }) {
  const { asPath } = useRouter();

  return (
    <li>
      {asPath == '/your-bag' ? (
        <span className={`xx-small`} aria-current="page">
          {text}
        </span>
      ) : (
        <a className={`xx-small`} href={link} tabIndex={0}>
          {text}
        </a>
      )}
    </li>
  );
}
